import React from 'react'
import { useSelector } from 'react-redux'
import { FormNames } from 'Constants/FormNames'
import {
	AccordionComponent,
	DatePickerMaskComponent,
	FormRowComponent,
	FormRowElement,
	Indent,
	InnInput,
	InputComponent,
	KppInput,
	OgrnInput,
	PhoneInput,
	UISizes,
} from 'LibNeo'
import { FieldNames } from 'Constants/FieldNames'
import { Validators, formsSelectors } from 'Modules'
import { ADDRESS_LABEL, TYPE_ORIGIN_ADDRESS } from 'Constants/Address.constants'
import { getDate } from 'Helpers'
import {
	BgAddresComponent,
	BgFormRowElement,
	bgLimitRequestSelector,
	getLockedText,
} from 'Pages/ibro'

export const CompanyInfo = () => {
	const getForm = useSelector(formsSelectors.getGlobalForm)
	const form = getForm(FormNames.BROKER.LIMIT)
	const item = useSelector(bgLimitRequestSelector.selectCurrentLimitRequest)
	const { locked_fields = [], required_fields } = item

	return (
		<>
			<AccordionComponent id="ContactInfo" titleText="Контактные данные" noExpand>
				<Indent top={24}>
					<BgFormRowElement
						fields={required_fields}
						fieldName={FieldNames.EMAIL}
						lockedFields={locked_fields}
						label="Email"
						lockedElem={item.email}
					>
						<InputComponent
							fieldName={FieldNames.EMAIL}
							form={form}
							fieldOptions={{
								initialValue: item[FieldNames.EMAIL],
								rules: [
									{
										validator: Validators.checkRequired({
											required: required_fields.includes(FieldNames.EMAIL),
										}),
									},
								],
							}}
						/>
					</BgFormRowElement>

					<BgFormRowElement
						fields={required_fields}
						fieldName={FieldNames.PHONE}
						lockedFields={locked_fields}
						label="Телефон"
						lockedElem={item.phone}
						size={UISizes.SMALL}
					>
						<PhoneInput
							form={form}
							label=""
							initialValue={item[FieldNames.PHONE]}
							required={required_fields.includes(FieldNames.PHONE)}
						/>
					</BgFormRowElement>
				</Indent>
			</AccordionComponent>
			<Indent top={48}>
				<AccordionComponent id="CompanyInfo" titleText="Сведения о регистрации" noExpand>
					<Indent top={24}>
						<FormRowComponent isString label="Наименование">
							<FormRowElement size={UISizes.MEDIUM} fixWidth>
								{item[FieldNames.NAME]}

								<InputComponent
									fieldName={FieldNames.NAME}
									form={form}
									fieldOptions={{
										initialValue: item[FieldNames.NAME],
									}}
									type="hidden"
								/>
							</FormRowElement>
						</FormRowComponent>

						<BgFormRowElement
							fields={required_fields}
							fieldName={FieldNames.OGRN}
							lockedFields={locked_fields}
							label="ОГРН"
							lockedElem={item[FieldNames.OGRN]}
						>
							<OgrnInput
								form={form}
								fieldName={FieldNames.OGRN}
								required={required_fields.includes(FieldNames.OGRN)}
								initialValue={item[FieldNames.OGRN] || undefined}
								label=""
							/>
						</BgFormRowElement>

						<FormRowComponent isString label="ИНН">
							<FormRowElement size={UISizes.MEDIUM} fixWidth>
								{item[FieldNames.INN]}

								<InputComponent
									fieldName={FieldNames.INN}
									form={form}
									fieldOptions={{
										initialValue: item[FieldNames.INN],
									}}
									type="hidden"
								/>
							</FormRowElement>
						</FormRowComponent>

						<BgFormRowElement
							fieldName={FieldNames.OGRNIP}
							fields={required_fields}
							lockedFields={locked_fields}
							label="ОГРНИП"
							lockedElem={item.ogrnip}
						>
							<OgrnInput
								form={form}
								fieldName={FieldNames.OGRNIP}
								required={required_fields.includes(FieldNames.OGRNIP)}
								initialValue={item[FieldNames.OGRNIP] || undefined}
								label=""
							/>
						</BgFormRowElement>

						<BgFormRowElement
							fields={required_fields}
							fieldName={FieldNames.AUTHINN}
							lockedFields={locked_fields}
							label="ИНН"
							lockedElem={getLockedText(item.authinn)}
						>
							<InnInput
								label=""
								fieldName={FieldNames.AUTHINN}
								form={form}
								initialValue={item[FieldNames.AUTHINN] || undefined}
								isTwelve
								required={required_fields.includes(FieldNames.AUTHINN)}
							/>
						</BgFormRowElement>

						<BgFormRowElement
							fields={required_fields}
							fieldName={FieldNames.KPP}
							lockedFields={locked_fields}
							label="КПП"
							lockedElem={item[FieldNames.KPP]}
						>
							<KppInput
								form={form}
								required={required_fields.includes(FieldNames.KPP)}
								initialValue={item[FieldNames.KPP] || undefined}
								label=""
							/>
						</BgFormRowElement>

						<BgFormRowElement
							fields={required_fields}
							fieldName={FieldNames.OKVEDANOVER}
							lockedFields={locked_fields}
							label="Основной ОКВЭД"
							lockedElem={item[FieldNames.OKVEDANOVER]}
						>
							<InputComponent
								form={form}
								fieldOptions={{
									rules: [
										{
											validator: Validators.checkRequired({
												required: required_fields.includes(FieldNames.OKVEDANOVER),
											}),
										},
									],
									initialValue: item[FieldNames.OKVEDANOVER] || undefined,
								}}
								fieldName={FieldNames.OKVEDANOVER}
							/>
						</BgFormRowElement>

						<BgAddresComponent
							form={form}
							defaultAddress={item[FieldNames.ADDRESSJUR]}
							fieldName={FieldNames.ADDRESSJUR}
							label={ADDRESS_LABEL.JURIDICAL_ADDRESS}
							origin={TYPE_ORIGIN_ADDRESS.BG_REQUEST_ADDRESS}
							lockedElem={item[FieldNames.ADDRESSJUR]?.result}
							fields={required_fields}
							lockedFields={locked_fields}
							fieldOptions={{
								rules: [
									{
										validator: Validators.checkRequired({
											required: required_fields?.includes(FieldNames.ADDRESSJUR),
										}),
									},
								],
							}}
						/>

						<BgFormRowElement
							fields={required_fields}
							fieldName={FieldNames.REGISTRATIONDATE}
							lockedFields={locked_fields}
							label="Дата гос. регистрации"
							lockedElem={getDate(item.registrationdate)}
							size={UISizes.SMALL}
						>
							<DatePickerMaskComponent
								field={FieldNames.REGISTRATIONDATE}
								form={form}
								initialValue={item[FieldNames.REGISTRATIONDATE]}
								fieldOptions={{
									rules: [
										{
											validator: Validators.checkRequired({
												required: required_fields?.includes(FieldNames.REGISTRATIONDATE),
											}),
										},
									],
								}}
							/>
						</BgFormRowElement>
					</Indent>
				</AccordionComponent>
			</Indent>
		</>
	)
}
